import React from "react";
import { Link } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetClose, SheetTitle } from "../ui/sheet";
import { NAV_ITEMS, CONTACT } from "../../mock";

const MobileNav = ({ pathname, transparent }) => (
  <div className="lg:hidden">
    <Sheet>
      <SheetTrigger aria-label="Open menu">
        <Menu size={26} className={transparent ? "text-white" : "text-[#3a3736]"} />
      </SheetTrigger>
      <SheetContent side="right" className="bg-[#f6f2ed] border-l border-[#e0d8cf] w-[80%] sm:w-[360px]">
        <div className="flex flex-col h-full pt-6">
          <SheetTitle asChild>
            <span className="brand-title text-xl text-[#3a3736]" style={{ letterSpacing: "0.12em" }}>
              ROGER MINNER
            </span>
          </SheetTitle>
          <span className="font-sans-el text-[0.6rem] tracking-[0.42em] uppercase mt-1 text-[#9a878b] mb-8">
            Homes
          </span>
          <nav className="flex flex-col">
            {NAV_ITEMS.map((item) => (
              <SheetClose asChild key={item.path}>
                <Link
                  to={item.path}
                  className={`font-serif-el text-2xl py-3 border-b border-[#e6ded4] transition-colors ${
                    pathname === item.path ? "text-[#6f5f62]" : "text-[#4a4644] hover:text-[#6f5f62]"
                  }`}
                >
                  {item.label}
                </Link>
              </SheetClose>
            ))}
          </nav>
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            className="mt-8 flex items-center justify-center gap-2 bg-[#6f5f62] text-white px-4 py-3 rounded-sm font-sans-el tracking-[0.14em] uppercase text-sm"
          >
            <Phone size={16} /> Call {CONTACT.phone}
          </a>
        </div>
      </SheetContent>
    </Sheet>
  </div>
);

export default MobileNav;
